import * as moment from "moment";

import { AnsweredQuestionWithId, DropdownOption } from "../questionnaires/model";
import { Link } from "../task/taskActions/models";
import { Profession } from "../adminUser/models";

export const MANAGER_FEEDBACK_ON_REPORT_KEY = "MANAGER_FEEDBACK_ON_REPORT_KEY";

export interface ManagerFeedbackOnReportQuestionnaireModel {
    questions: AnsweredQuestionWithId[];
    eTag: string;
}

export interface ParentConsultationModel {
    readonly taskDescription: string;
    readonly consultationCompletedBy: Link;
    readonly consultationCompletedDate: moment.Moment;
    readonly consultationUserProfession: Profession;
    readonly reportCompletedBy: Link;
    readonly reportCompletedDate: moment.Moment;
    readonly reportUserProfession: Profession;
}

export const DATE_FORMAT = "DD-MM-YYYY";

export const ManagerFeedbackOnReportSectionTitles = {
    FeedbackSurvey: "Feedback Survey"
};

export const ManagerFeedbackOnReportSections = {
    FeedbackSurvey: "FeedbackSurvey"
};

export enum RecommendationsRealisticityLevel {
    VeryRealistic = "VeryRealistic",
    SomewhatRealistic = "SomewhatRealistic",
    SomewhatUnrealistic = "SomewhatUnrealistic",
    VeryUnrealistic = "VeryUnrealistic",
    NoRecommendations = "NoRecommendations"
}

export const wereRecomendationsRealisticOptions: DropdownOption[] = [
    { text: "Very Realistic", value: RecommendationsRealisticityLevel.VeryRealistic, order: 1 },
    { text: "Somewhat Realistic", value: RecommendationsRealisticityLevel.SomewhatRealistic, order: 2 },
    { text: "Somewhat Unrealistic", value: RecommendationsRealisticityLevel.SomewhatUnrealistic, order: 3 },
    { text: "Very Unrealistic", value: RecommendationsRealisticityLevel.VeryUnrealistic, order: 4 },
    { text: "No recommendations were made", value: RecommendationsRealisticityLevel.NoRecommendations, order: 5 }
];

export enum ReturnToWorkDateAccuracyLevel {
    NotApplicable = "NotApplicable",
    NotGiven = "NotGiven",
    VeryAccurate = "VeryAccurate",
    NotVeryAccurateReturnedBefore = "NotVeryAccurateReturnedBefore",
    NotVeryAccurateReturnedAfter = "NotVeryAccurateReturnedAfter"
}

export const returnToWorkDateAccuracyOptions: DropdownOption[] = [
    {
        text: "Not applicable, the member of staff was At Work",
        value: ReturnToWorkDateAccuracyLevel.NotApplicable,
        order: 1,
        old: true
    },
    {
        text: "Not applicable",
        value: ReturnToWorkDateAccuracyLevel.NotApplicable,
        order: 1,
    },
    {
        text: "The OH Adviser did not give a predicted return to work date",
        value: ReturnToWorkDateAccuracyLevel.NotGiven,
        order: 2
    },
    {
        text: "Very accurate, the individual returned on or near the predicted return to work date",
        value: ReturnToWorkDateAccuracyLevel.VeryAccurate,
        order: 3
    },
    {
        text: "Not very accurate, the member of staff returned BEFORE the predicted return to work date",
        value: ReturnToWorkDateAccuracyLevel.NotVeryAccurateReturnedBefore,
        order: 4
    },
    {
        text: "Not very accurate, the member of staff returned AFTER the predicted return to work date",
        value: ReturnToWorkDateAccuracyLevel.NotVeryAccurateReturnedAfter,
        order: 5
    }
];

export enum OverallExperienceLevel {
    One = "1",
    Two = "2",
    Three = "3",
    Four = "4",
    Five = "5",
    Six = "6",
    Seven = "7",
    Eight = "8",
    Nine = "9",
    Ten = "10"
}

export const overallExperienceOptions: string[] = [
    OverallExperienceLevel.One,
    OverallExperienceLevel.Two,
    OverallExperienceLevel.Three,
    OverallExperienceLevel.Four,
    OverallExperienceLevel.Five,
    OverallExperienceLevel.Six,
    OverallExperienceLevel.Seven,
    OverallExperienceLevel.Eight,
    OverallExperienceLevel.Nine,
    OverallExperienceLevel.Ten
];

export const parseConsultationDataModel = (model: ParentConsultationModel) => {
    return {
        ...model,
        consultationCompletedDate: model.consultationCompletedDate && moment(model.consultationCompletedDate),
        reportCompletedDate: model.reportCompletedDate && moment(model.reportCompletedDate)
    };
};
